import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
    root: {
        backgroundColor: '#f6bd17',
        borderRadius: 4,
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 20,
        boxShadow: '0px 3px 11px 0px #e8eafc, 0px 3px 3px -2px rgba(178,178,178,0.1), 0px 1px 8px 0px rgba(154,154,154,0.1)',
        marginBottom: 24,
    },
    textSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    title: {
        fontSize: 16,
        fontWeight: 700,
        color: '#0c0644',
        lineHeight: 'normal',
        display: 'block',
    },
    body: {
        fontSize: 16,
        color: '#0c0644',
        lineHeight: 'normal',
        display: 'block',
    },
    bodyHighlight: {
        fontWeight: 500,
    },
    verifyButton: {
        backgroundColor: '#008ea9',
        color: '#ffffff',
        borderRadius: 4,
        padding: '8px 12px',
        fontSize: 14,
        fontWeight: 500,
        textTransform: 'uppercase',
        minWidth: 0,
        '&:hover': {
            backgroundColor: '#007a93',
        },
    },
});

export default styles;
export const useStyles = makeStyles(styles);
